// ✅ Trekkin.app — TrailItem.jsx v1.1.3 (FINAL FINAL)
// 🔥 Ativar trilho → ativa + resetToMap() (FECHA PAINÉIS!)
// 🔥 Zero alterações extra

import TrekkinButton from "./TrekkinButton.jsx";
import { showToast } from "./NotifyToast.jsx";
import { usePanelsStore } from "../stores/usePanelsStore";
import { useAuthStore } from "../stores/useAuthStore";
import { useCan } from "../hooks/useCan.js";
import { db } from "../firebaseConfig";
import { ref, set } from "firebase/database";
import { getTrailNameKeys } from "../utils/trailNameSync.js";
import { useTranslate } from "../i18n/useTranslate";
import {
  addPendingTrailDelete,
  removePendingTrailDelete,
} from "../utils/trailPendingDelete.js";

function formatTrailDistance(trail) {
  const raw = trail?.dist ?? trail?.distanceKm ?? trail?.distance ?? "";
  const text = String(raw || "").trim();
  if (!text || text === "—") return "—";
  const numeric = Number(text.replace(",", ".").replace(/[^0-9.]+/g, ""));
  if (Number.isFinite(numeric) && numeric > 0) return `${numeric.toFixed(2)} km`;
  const cleaned = text.replace(/\s*km\s*$/i, "").trim();
  return cleaned ? `${cleaned} km` : "—";
}

export default function TrailItem({
  trail,
  base = "/",
  setTrailData,
  setActivePanel,
  handleStartTrail,
  handleStopTrail,
  isActive = false,
  saveTrilhos,
  trilhos,
  folderOptions = {},
  currentFolderId = "",
  onMoveFolder,
  canManageFolders = false,
}) {
  const resetToMap = usePanelsStore.getState().resetToMap;
  const user = useAuthStore.getState().user;
  const translate = useTranslate();
  const canEdit = useCan("PanelTrailDetails", "edit_trail");
  const canDelete = useCan("PanelTrailCreate", "delete_trail");
  const canUploadTrail =
    user?.role === "admin" || useCan("PanelNav", "upload_gpx");

  const cloudState = trail?.cloud?.file || trail?.cloud?.url
    ? translate("history.cloud.synced")
    : canUploadTrail
    ? translate("history.cloud.pending")
    : translate("history.cloud.local");
  const cloudColor =
    trail?.cloud?.file || trail?.cloud?.url ? "#28a745" : "#999";

  const handleRename = () => {
    if (!canEdit) {
      showToast(translate("trailDetails.noPermissionEdit"));
      return;
    }
    const currentName =
      trail?.nome || trail?.name || translate("trail.fallback.trail");
    const next = window.prompt(
      translate("trailItem.prompt.rename"),
      currentName
    );
    if (next == null) return;
    const trimmed = next.trim();
    if (!trimmed || trimmed === currentName) return;
    const updated = trilhos.map((t) =>
      t.id === trail.id ? { ...t, nome: trimmed, name: trimmed } : t
    );
    saveTrilhos(updated);
    setTrailData?.({ ...trail, nome: trimmed, name: trimmed });
    if (user?.uid) {
      const keys = getTrailNameKeys(trail);
      keys.forEach((key) => {
        set(ref(db, `userTrailNames/${user.uid}/${key}`), {
          name: trimmed,
          updatedAt: Date.now(),
        }).catch(() => {});
      });
    }
    showToast(translate("trailDetails.nameUpdated"), "success");
  };

  const handleDelete = async () => {
    if (!canDelete) {
      showToast(translate("trailDetails.noPermissionDelete"));
      return;
    }
    const getCloudFilename = (cloud) => {
      let filename = null;
      if (cloud?.file) filename = cloud.file;
      else if (cloud?.url) {
        try {
          const url = new URL(cloud.url);
          filename = url.pathname.split("/").pop() || null;
        } catch {
          filename = cloud.url.split("?")[0].split("/").pop() || null;
        }
      }
      if (!filename) return null;
      try {
        return decodeURIComponent(filename);
      } catch {
        return filename;
      }
    };
    const updated = trilhos.filter((t) => t.id !== trail.id);
    saveTrilhos(updated);
    const trailLabel =
      trail?.nome || trail?.name || translate("trail.fallback.trail");
    showToast(translate("trailItem.toast.deleted", { name: trailLabel }), "info");
    const filename = getCloudFilename(trail?.cloud);
    if (filename && user?.uid) {
      addPendingTrailDelete(filename);
      try {
        const data = await fetch(
          "https://www.trekkin.pt/app/app-upload/delete-user-gpx.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              uid: user.uid,
              filename,
              type: "trails",
            }),
          }
        ).then((res) => res.json());
        if (data?.ok || data?.error === "file not found") {
          removePendingTrailDelete(filename);
        }
        try {
          const plannedRaw =
            localStorage.getItem("plannedTrailFiles") || "[]";
          const plannedList = JSON.parse(plannedRaw);
          if (Array.isArray(plannedList)) {
            const next = plannedList.filter((f) => f !== trail.cloud.file);
            localStorage.setItem(
              "plannedTrailFiles",
              JSON.stringify(next)
            );
          }
        } catch {}
      } catch {
        // silencioso por design
      }
    }
  };

  return (
    <div style={{
      padding: "12px 14px",
      marginTop: 10,
      background: "rgba(255,255,255,0.95)",
      borderRadius: 12,
      border: "1px solid rgba(0,0,0,0.08)",
      display: "flex",
      flexDirection: "column",
      gap: 8,
    }}>
      
      {/* Nome + dist + D+ */}
      <div>
        <div
          style={{ fontWeight: 600, fontSize: 15, cursor: "pointer" }}
          onClick={handleRename}
          title={translate("trailItem.title.editName")}
        >
          {trail.nome || trail.name || translate("trail.fallback.trail")}
        </div>
        <div
          style={{
            marginTop: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 8,
          }}
        >
          <span style={{ fontSize: 12, color: "#666" }}>
            {formatTrailDistance(trail)} · {trail.elev || "—"}
          </span>
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              gap: 0,
              fontSize: 11,
            }}
          >
            <span style={{ color: cloudColor }}>{cloudState}</span>
          </span>
        </div>
      </div>

      {canManageFolders && (
        <label style={{ display: "grid", gridTemplateColumns: "auto minmax(0,1fr)", alignItems: "center", gap: 8, fontSize: 12, fontWeight: 700 }}>
          <span>{translate("nav.trailFolders.moveTo")}</span>
          <select
            value={currentFolderId}
            onChange={(event) => onMoveFolder?.(trail, event.target.value)}
            style={{ width: "100%", minWidth: 0, minHeight: 38, borderRadius: 9, padding: "6px 8px" }}
          >
            <option value="">{translate("nav.trailFolders.unfiled")}</option>
            {Object.entries(folderOptions)
              .sort(([, a], [, b]) => String(a?.name || "").localeCompare(String(b?.name || "")))
              .map(([id, folder]) => <option key={id} value={id}>{folder?.name || id}</option>)}
          </select>
        </label>
      )}

      {/* Botões */}
      <div style={{ display: "flex", gap: 10, marginTop: 6 }}>

        {/* 1️⃣ Detalhes */}
        <TrekkinButton
          icon="details.svg"
          variant="ghost"
          style={{ flex: 1, flexDirection: "column", gap: 4, padding: "8px 0" }}
          onClick={() => {
            setTrailData({ ...trail, __source: "trails" });
            setActivePanel("trailDetails");
          }}
        >
          <span style={{ fontSize: 10, lineHeight: 1, color: "#333" }}>
            {translate("history.action.details")}
          </span>
        </TrekkinButton>

        {/* 2️⃣ Ativar Trilho → ativa + fecha painéis */}
        <TrekkinButton
          icon="trail.svg"
          variant="primary"
          className="tk-neutral-action-button"
          style={{ flex: 1, flexDirection: "column", gap: 4, padding: "8px 0" }}
          onClick={async () => {
            await handleStartTrail(trail);
            resetToMap(); // ←🔥 FECHA OS PAINÉIS COMO TU QUERES
          }}
        >
          <span style={{ fontSize: 10, lineHeight: 1, color: "#333" }}>
            {translate("history.action.follow")}
          </span>
        </TrekkinButton>

        {/* 🛑 Desativar Trilho */}
        <TrekkinButton
          icon="stop.svg"
          variant="ghost"
          disabled={!isActive}
          style={{
            flex: 1,
            opacity: isActive ? 1 : 0.4,
            flexDirection: "column",
            gap: 4,
            padding: "8px 0",
          }}
          onClick={() => {
            if (!isActive) return;
            handleStopTrail?.();
          }}
        >
          <span style={{ fontSize: 10, lineHeight: 1, color: "#333" }}>
            {translate("nav.record.stop")}
          </span>
        </TrekkinButton>

        {/* 3️⃣ Eliminar */}
        <TrekkinButton
          icon="trash.svg"
          variant="danger"
          className="tk-neutral-action-button"
          style={{ flex: 1, flexDirection: "column", gap: 4, padding: "8px 0" }}
          disabled={!canDelete}
          onClick={handleDelete}
        >
          <span style={{ fontSize: 10, lineHeight: 1, color: "#333" }}>
            {translate("history.action.delete")}
          </span>
        </TrekkinButton>
      </div>
    </div>
  );
}
